export const AXIZ_API_ROUTES = {
    AUTH: {
        TOKEN: '/auth/token',
    },
    PRICE_LIST: {
        SEARCH: '/api/services/app/PriceList/SearchPriceList',
        GET_VIEWS: '/api/services/app/PriceList/GetViews',
    },
    BRANDS: {
        FETCH: '/api/services/app/PriceList/FetchBrands',
    },
    SALES_REQUEST: {
        CREATE: '/api/services/app/SalesRequest/CreateSalesRequest',
        RETRY: '/api/services/app/SalesRequest/RetrySalesRequest',
    },
    CUSTOMERS: {
        GET_ALL: '/api/services/app/Customers/GetAll',
        GET_BY_ID: '/api/services/app/Customers/GetCustomerById',
        CREATE: '/api/services/app/Customers/CreateFullCustomer',
        UPDATE_OR_SAVE: '/api/services/app/Customers/UpdateOrSaveCustomer',
        DELETE: '/api/services/app/Customers/Delete',
    },
    CUSTOMER_ADDRESS: {
        GET_BY_CUSTOMER_ID: '/api/services/app/CustomerAddresses/GetByCustomerId',
        CREATE_OR_EDIT: '/api/services/app/CustomerAddresses/CreateOrEdit',
        DELETE: '/api/services/app/CustomerAddresses/Delete',
    },
    CUSTOMER_CONTACT_PERSON: {
        GET_BY_ID: '/api/services/app/ContactPerson/GetContactPersonForEditByCustomerId',
        CREATE_OR_EDIT: '/api/services/app/ContactPerson/CreateOrEdit',
        DELETE: '/api/services/app/ContactPerson/Delete',
        GET_TITLES: '/api/services/app/ContactPerson/GetPersonTitles',
    },
    EXCHANGE_RATE: {
        GET: '/api/services/app/RateOfExchange/GetRateOfExchange',
    },
    SALES_ORDERS: {
        GET_ALL: '/api/services/app/SalesOrder/GetAll',
        GET_BY_ID: '/api/services/app/SalesOrder/GetSalesOrdersById',
        CREATE: '/api/services/app/SalesOrder/Create',
        UPDATE: '/api/services/app/SalesOrder/Update',
    },
    POD: {
        DOWNLOAD: '/File/DownloadPOD',
    },
    BILLING: {
        GET_BREAKDOWN: '/api/services/app/Invoices/GetBillingBreakdownPerTenant',
    },
    DEALS: {
        SEARCH: '/api/services/app/Deals/SearchDeal',
        FIND: '/api/services/app/Deals/FindDeal',
    },
    PRODUCTS: {
        SEARCH: '/api/services/app/Products/SearchProducts',
        FIND_BY_ID: '/api/services/app/Products/FindProductById',
    },
};
//# sourceMappingURL=apiRoutes.js.map